import { Injectable } from '@angular/core';
import { ETipoDocumentoSUNAT } from '@core/enums/tipoDocumentoSUNAT.enum';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly STORAGE_KEY_RUC_EMAIL = 'ventaclick_ruc_email';
  private readonly STORAGE_KEY_CONFIG = 'ventaclick_local_config';
  // datos para configurar
  private readonly config = new BehaviorSubject<{
    ver_imagen: boolean;
    ultimo_tipo_documento_sunat: ETipoDocumentoSUNAT;
  }>({
    ver_imagen: false,
    ultimo_tipo_documento_sunat: ETipoDocumentoSUNAT.NOTA_VENTA,
  });

  get config$() {
    return this.config.asObservable();
  }

  private saveConfig() {
    try {
      localStorage.setItem(this.STORAGE_KEY_CONFIG, JSON.stringify(this.config.value));
    } catch {
      // Si el almacenamiento falla (ejemplo: espacio lleno), no hacemos nada, simplemente no se guardará la configuración
    }
  }
  // safe loading, si hay storage crea uno nuevo con valores por defecto
  loadConfig() {
    const stored = localStorage.getItem(this.STORAGE_KEY_CONFIG);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        this.config.next({
          ...this.config.value,
          ver_imagen: parsed.ver_imagen ?? this.config.value.ver_imagen,
          ultimo_tipo_documento_sunat:
            parsed.ultimo_tipo_documento_sunat ?? this.config.value.ultimo_tipo_documento_sunat,
        });
      } catch {
        // Si el JSON es inválido, reseteamos al valor por defecto
        this.saveConfig();
      }
    } else {
      this.saveConfig();
    }
  }

  setVerImagen(value: boolean) {
    this.config.next({
      ...this.config.value,
      ver_imagen: value,
    });
    this.saveConfig();
  }
  getVerImagen() {
    return this.config.value.ver_imagen;
  }
  setUltimoTipoDocumentoSUNAT(value: ETipoDocumentoSUNAT) {
    this.config.next({
      ...this.config.value,
      ultimo_tipo_documento_sunat: value,
    });
    this.saveConfig();
  }
  getUltimoTipoDocumentoSUNAT() {
    return this.config.value.ultimo_tipo_documento_sunat;
  }

  removeRucAndEmail() {
    try {
      localStorage.removeItem(this.STORAGE_KEY_RUC_EMAIL);
    } catch {
      // Si el almacenamiento falla, no hacemos nada
    }
  }

  clear() {
    try {
      localStorage.removeItem(this.STORAGE_KEY_CONFIG);
      localStorage.removeItem(this.STORAGE_KEY_RUC_EMAIL);
    } catch {
      // Si el almacenamiento falla, no hacemos nada
    }
    this.config.next({
      ver_imagen: false,
      ultimo_tipo_documento_sunat: ETipoDocumentoSUNAT.NOTA_VENTA,
    });
  }

  setRucAndEmail(ruc: string, email: string) {
    const sessionData = { ruc, email };
    try {
      localStorage.setItem(this.STORAGE_KEY_RUC_EMAIL, JSON.stringify(sessionData));
    } catch {
      // Si el almacenamiento falla (ejemplo: espacio lleno), no hacemos nada, simplemente no se guardará la sesión
    }
  }
  getRucAndEmail() {
    const stored = localStorage.getItem(this.STORAGE_KEY_RUC_EMAIL);
    if (stored) {
      try {
        return JSON.parse(stored) as { ruc: string; email: string };
      } catch {
        return null;
      }
    }
    return null;
  }
}
